module.exports = __webpack_public_path__ + "img/kommune-1866.44cd7884.svg";